import { Component, For } from 'solid-js';

interface FloatingShape {
  id: number;
  size: number;
  x: number;
  y: number;
  delay: number;
  duration: number;
  opacity: number;
}

const AnimatedBackground: Component = () => {
  // Generate random floating shapes
  const shapes: FloatingShape[] = Array.from({ length: 6 }, (_, i) => ({
    id: i,
    size: Math.random() * 300 + 100,
    x: Math.random() * 100,
    y: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 10 + 10,
    opacity: Math.random() * 0.15 + 0.05,
  }));

  return (
    <div class="fixed inset-0 overflow-hidden pointer-events-none -z-10">
      {/* Gradient overlay */}
      <div class="absolute inset-0 bg-gradient-to-br from-primary-500/20 via-transparent to-accent-500/20 dark:from-primary-900/30 dark:to-accent-900/30" />

      {/* Floating blur shapes */}
      <For each={shapes}>
        {(shape) => (
          <div
            class="absolute rounded-full blur-3xl animate-float"
            style={{
              width: `${shape.size}px`,
              height: `${shape.size}px`,
              left: `${shape.x}%`,
              top: `${shape.y}%`,
              opacity: shape.opacity,
              background: shape.id % 2 === 0
                ? 'linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(168, 85, 247, 0.4))'
                : 'linear-gradient(135deg, rgba(244, 63, 94, 0.3), rgba(251, 146, 60, 0.3))',
              'animation-delay': `${shape.delay}s`,
              'animation-duration': `${shape.duration}s`,
              transform: 'translate(-50%, -50%)',
            }}
          />
        )}
      </For>

      {/* Grid pattern overlay */}
      <div
        class="absolute inset-0 opacity-[0.02] dark:opacity-[0.05]"
        style={{
          'background-image': `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          'background-size': '50px 50px',
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
